import { FormattedMessage } from "react-intl";
import { Heading } from "@lendcord/concord";
import { ProfileField } from "@/features/profile/components/ProfileField";

// Mirrors KycDetails' own view-mode layout (grid shapes, static labels/
// headings) with every value swapped for ProfileField's skeleton — same
// footprint while `profile` is still loading, no reflow once it arrives.
export function KycDetailsSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <ProfileField labelId="lender.profile.panLabel" value="" loading />
        <ProfileField labelId="lender.profile.aadhaarLabel" value="" loading />
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <ProfileField labelId="lender.profile.fathersNameLabel" value="" loading />
        <ProfileField labelId="lender.profile.dateOfBirthLabel" value="" loading />
      </div>

      <ProfileField labelId="lender.profile.genderLabel" value="" loading />

      <Heading level={4} className="text-accent-600">
        <FormattedMessage id="lender.profile.nomineeDetailsHeading" />
      </Heading>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <ProfileField labelId="lender.profile.nomineeNameLabel" value="" loading />
        <ProfileField labelId="lender.profile.nomineeContactNumberLabel" value="" loading />
      </div>

      <ProfileField labelId="lender.profile.nomineeRelationshipLabel" value="" loading />
    </div>
  );
}
